import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { FC } from "react";
import Label from "../label/label";
import Togglebox from "../togglebox/togglebox";

interface AutoCreateStepProps {
    onNext: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onBack: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const AutoCreateStep: FC<AutoCreateStepProps> = ({ onNext, onBack }) => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    const onAutoCreateFloorGroupChange = () => {
        const newValue = !values.autoCreateFloorGroup;

        if (newValue === false) {
            setFieldValue('autoCreateAccessProfile', false);
        }

        setFieldValue('autoCreateFloorGroup', newValue);
    }

    return <div className='flex flex-col h-full px-2 py-1 relative space-y-1'>
        <span className={`text-portal-blue-primary-shade2 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.permissions)}
        </span>
        <div className="flex flex-col">
            <Label htmlFor='autoCreateFloorGroup'
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.createFloorGroupsPerFloor)}</Label>
            <Togglebox name="autoCreateFloorGroup" label={''} onChanged={onAutoCreateFloorGroupChange} />
        </div>
        <div className="flex flex-col">
            <Label htmlFor='autoCreateFullAccessFloorGroup'
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.createFullAccessFloorGroup)}</Label>
            <Togglebox name="autoCreateFullAccessFloorGroup" label={''} />
        </div>
        <div className="flex flex-col">
            <Label htmlFor='autoCreateAccessProfile'
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.createFullAccessProfile)}</Label>
            <Togglebox name="autoCreateAccessProfile" label={''} disabled={!values.autoCreateFloorGroup} />
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5"
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="button"
                    data-cy="nextButton"
                    onClick={onNext}>{translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>
}

export default AutoCreateStep;